/**
 * Test if a Mapbox layer is an agreements layer.
 * Agreements layers are any layer starting with 'properties-'.
 * All agreements layers in the map style should start with 'properties-' and no other layers should.
 */
export const isAgreementLayer = (mapboxLayer: { id: string }): boolean =>
  mapboxLayer.id.startsWith('properties-');

/**
 * Test if a Mapbox layer is an agreements highlight layer.
 * Agreements highlight layers are any layer starting with 'highlight-properties-'.
 * All agreements highlight layers in the map style should start with 'highlight-properties-'
 * and no other layers should.
 */
export const isAgreementHighlightLayer = (mapboxLayer: { id: string }): boolean =>
  mapboxLayer.id.startsWith('highlight-properties-');
